export const adminHomeMock = {
    header: 'Admin page',
    content: 'Here is admin page',
};

export const adminHomeDataFetch = async () => adminHomeMock;
